import { visibilityFormSchema } from "shared/form/visibilitySchema";
import { z } from "zod";

const internalMessagesFormFieldSchema = z.array(
  z.object({
    uuid: z.string().optional(),
    message: z.string().min(1, "Beskrivelse må fylles ut"),
    contexts: z.string().array().optional(),
    user: z.string().optional(),
    updatedAt: z.string().optional(),
  }),
);

export type InternalMessagesFormField = z.infer<
  typeof internalMessagesFormFieldSchema
>;

export const internalMessagesFormSchema = z.object({
  internalMessages: internalMessagesFormFieldSchema,
  visibility: visibilityFormSchema.optional(), // Visibility is copied for internalMessages related to events
});

export type InternalMessagesForm = z.infer<typeof internalMessagesFormSchema>;
